import styled, { css } from 'styled-components';
import { colors, devices, maxLinesStyle } from '../../../base/styled/variables.styled';
import { typography, fontWeights } from '../../../base/styled/typography.style';
export const EnrollmentCardContainer = styled.article `
  display: grid;
  grid-template-columns: 280px 1fr 300px;
  grid-template-areas: "image content meta";
  gap: 16px;
  border-radius: 8px;
  background-color: ${({ $inverse }) => $inverse ? colors.brand500 : 'transparent'};
  overflow: hidden;
  width: 100%;

  &:hover {
    background-color: ${({ $inverse }) => $inverse ? colors.brand800 : colors.brand75};
  }

  @media ${devices.tablets} {
    grid-template-columns: 280px 1fr;
    grid-template-rows: auto auto;
    grid-template-areas: 
      "image content"
      "image meta";
  }

  @media ${devices.mobile} {
    display: flex;
    flex-direction: column;
  }
`;
export const CardTitle = styled.h3 `
  ${css(typography.headline3)}
  font-weight: ${fontWeights.regular};
  margin: 0;
  color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.neutral800};

  strong {
    font-weight: ${fontWeights.bold};
    color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.neutral800};
  }
`;
export const ImageColumn = styled.div `
  grid-area: image;
  width: 280px;
  height: 194px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;

  @media ${devices.mobile} {
    width: 100%;
    height: auto;
    aspect-ratio: 16/9;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
export const ContentColumn = styled.div `
  grid-area: content;
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;

  @media ${devices.tablets} {
    padding: 16px 16px 0 0;
  }

  @media ${devices.mobile} {
    padding: 16px;
  }

  /* Reset margins for inner elements to ensure exact gap control */
  > * {
    margin: 0 !important;
  }

  /* Target specific atoms if they have wrapper divs or classes */
  .cmp-title h3 {
    margin: 0 !important;
  }
`;
export const MetaColumn = styled.div `
  grid-area: meta;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-left: 1px solid ${({ $inverse }) => $inverse ? colors.brand300 : colors.neutral300};

  @media ${devices.tablets} {
    border-left: none;
    padding: 0 16px 16px 0;
  }

  @media ${devices.mobile} {
    padding: 0 16px 16px 16px;
  }
`;
export const Description = styled.div `
  ${typography.body2};
  color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.neutral500};
  ${maxLinesStyle(1)};

  @media ${devices.tablets} {
    -webkit-line-clamp: 3;
  }
`;
export const MetaInfo = styled.div `
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
export const StatusText = styled.div `
  ${typography.body3};
  color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.neutral500};
  
  strong {
    ${typography.body3Highlight};
    color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.neutral500};
  }
`;
export const DateText = styled.div `
  ${typography.body3};
  color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.neutral500};

  strong {
    ${typography.body3Highlight};
    color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.neutral500};
  }
`;
export const ProgressWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: 2px; 
  margin-top: 4px;
  margin-bottom: 12px;
`;
export const ProgressLabel = styled.span `
  ${typography.body3};
  color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.neutral500};
`;
export const ProgressBarContainer = styled.div `
  width: 100%;
  height: 8px;
  background-color: ${colors.neutral200};
  border-radius: 4px;
  overflow: hidden;

  ${EnrollmentCardContainer}:hover & {
    background-color: ${({ $inverse }) => !$inverse ? colors.neutral000 : colors.neutral200};
  }
`;
export const ProgressBarFill = styled.div `
  height: 100%;
  width: ${props => props.$progress}%;
  background-color: ${({ $inverse }) => $inverse ? colors.brand200 : colors.brand500};
  border-radius: 4px;
  transition: width 0.3s ease;
`;
export const ButtonWrapper = styled.div `
  display: flex;
  flex-direction: row;
  gap: 12px;
  margin-top: auto;
  width: 100%;
`;
//# sourceMappingURL=EnrollmentCard.style.js.map